(function ($) {

RVwys.plugin['dynamicbar'] = true;



 $(document).bind('editorReady',function(){
	 $('.mini_htmlModeSource').click(function(){
		 //RVwys.clearUiWYSI();
		 
		 
		 
			var UI = UIkit;
			var onInsert = function(){

	        	$('#frameBody').contents().find('.RVWYSIWYGAREA').each(function(){
	    			$(this).attr('contenteditable',true);
	    			$(this).addClass('editorCurrent');
	    			$(this).placeHoldersRaw();
	    		});
	        	$('#frameBody').contents().find('.design-block .layoutfix').addClass('layoutCurrent');
	        	//alert( modal.element.find('#aHTMLsource').val())
	        	$(RVwys.currentiFrame).html( modal.element.find('#aHTMLsource').val()).placeHoldersRaw();
	        	modal.hide();
			};
			var oncancel  = function(){
				 $('#frameBody').contents().find('.RVWYSIWYGAREA').each(function(){
		    			$(this).attr('contenteditable',true);
		    			$(this).addClass('editorCurrent');
		    			$(this).placeHoldersRaw();
		    		});
		          $('#frameBody').contents().find('.design-block .layoutfix').addClass('layoutCurrent');
		         
				modal.hide();
			};
			var options   = {
					bgclose:false, 
					keyboard:false, 
					modal:false
					};
			
			var modal = UI.modal.dialog(([
			                              '<div class="uk-margin uk-modal-header"><h2>'+rvLang('Source')+'</h2><span class="uk-modal-close uk-icon-close"></span></div>',
			                              '<div class="uk-margin uk-modal-content">'+$('#viewHTMLsource').html()+'</div>',
			                              '<div class="uk-modal-footer uk-text-left"><button class="uk-button uk-button-success uk-button-primary js-modal-confirm">'+rvLang('Ok')+'</button>',
			                              '<button class="uk-button js-modal-confirm-cancel">'+rvLang('Cancel')+'</button></div>',
			                              ]).join(""), options);
			var  sHTML =  $('<div>'+$(RVwys.currentiFrame).html()+'</div>').remove('history').unplaceHolders('textarea');
			modal.element.find('#aHTMLsource').html(sHTML.html().replace(/\</img,'&lt;').replace(/\>/img,'&gt;'));
			modal.element.find(".js-modal-confirm-cancel").on("click", function(){
				 oncancel();
				
			}).end().find(".uk-button-success").on("click", function(){
				onInsert();
				
			});
			modal.show();
		 
	 });
 });
 
 
 RVwys.designViewAddEvent('mouseup',function(e){});
 
 RVwys.designViewAddEvent('keyup',function(e){});


 
})(jQuery);